import React from "react"
import autobind from "class-autobind"
import { IRecord, IDeviceDocument } from "../../../../models"
import strings from "../../../../localization/strings"
import * as api from "../../../../api"
import { Paper, CircularProgress, Table, TableHeader, TableHeaderColumn, TableBody, TableRow, TableRowColumn } from "material-ui"
import PunchImageToolTipColumn from "../../../punch/PunchImageToolTipColumn"
import PunchMapToolTipColumn from "../../../punch/PunchMapToolTipColumn"
import ExceptionColumn from "../../../layout/RecordExceptionColumn"
import * as utils from "../../../../helpers/utils"
import * as timeHelper from "../../../../helpers/timeHelper"
import moment from "moment"
import AccountStore from "../../../../stores/AccountStore"

interface IProps {
    record: IRecord
}
interface IState {
    loading: boolean
    records: IRecord[]
    devices: IDeviceDocument[]
}

export default class BioExceptionDayRecordTable extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            records: [],
            devices: [],
        }
        autobind(this)
    }

    componentDidMount() {
        this.getDayPunches(this.props.record)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.record.Punch.Id !== nextProps.record.Punch.Id &&
            this.getDayPunches(nextProps.record)
    }

    getDayPunches(record: IRecord) {
        this.setState({ loading: true, records: [], devices: [] }, () =>
            api.getUserDayRecords(record.UserId, moment(timeHelper.keepConvertUTCToLocal(this.props.record.Punch.DateTimeLocal)).utc(true).format()).then(res => {
                const deviceIds = []
                const getDevices = []
                res.data.forEach(record => {
                    const deviceId = record.Punch.DeviceId
                    if (deviceId && deviceIds.indexOf(deviceId) === -1) {
                        deviceIds.push(deviceId)
                        const getDevice = new Promise((resolve, reject) =>
                            api.getDevice(deviceId).then(res => resolve(res.data))
                        )
                        getDevices.push(getDevice)
                    }
                })
                Promise.all(getDevices).then(devices =>
                    this.setState({
                        loading: false,
                        records: res.data,
                        devices
                    })
                )
            })
        )
    }

    render() {
        const showLiveness = AccountStore.getLivenessDetectionEnabled()
        return (
            <Paper>
                {this.state.loading ?
                    <div className="spinner" style={{ paddingBottom: "2em" }}>
                        <CircularProgress />
                    </div> :
                    <Table
                        selectable={false}
                        multiSelectable={false}
                    >
                        <TableHeader
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            enableSelectAll={false}
                        >
                            <TableRow>
                                <TableHeaderColumn>{strings.Image}</TableHeaderColumn>
                                <TableHeaderColumn>{strings.Map}</TableHeaderColumn>
                                <TableHeaderColumn>{strings.Location}</TableHeaderColumn>
                                <TableHeaderColumn>{strings.Device_Name}</TableHeaderColumn>
                                <TableHeaderColumn>{strings.Biometric_Score}</TableHeaderColumn>
                                {showLiveness &&
                                    <TableHeaderColumn>{strings.Liveness_Score}</TableHeaderColumn>
                                }
                                <TableHeaderColumn>{strings.Exception}</TableHeaderColumn>
                                <TableHeaderColumn>{strings.Date}</TableHeaderColumn>
                                <TableHeaderColumn>{strings.Time}</TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody
                            displayRowCheckbox={false}
                            showRowHover={false}
                        >
                            {this.state.records.filter(record => record.Punch.ImageID !== null).map((row, index) => {
                                const device = this.state.devices.find(device => device.Id === row.Punch.DeviceId)
                                const dateTimeLocal = moment(timeHelper.keepConvertUTCToLocal(row.Punch.DateTimeLocal))
                                return (
                                    <TableRow key={index}>
                                        <TableRowColumn><PunchImageToolTipColumn punch={row.Punch} toolTipKey="BioExceptionDayRecordImage" /></TableRowColumn>
                                        <TableRowColumn><PunchMapToolTipColumn punch={row.Punch} toolTipKey="BioExceptionDayRecordMap" /></TableRowColumn>
                                        <TableRowColumn>{row.LocationName}</TableRowColumn>
                                        <TableRowColumn>{device && device.Name}</TableRowColumn>
                                        <TableRowColumn>{utils.getBiometricScore(row.Punch)}</TableRowColumn>
                                        {showLiveness &&
                                            <TableRowColumn>{utils.getLivenessScore(row.Punch)}</TableRowColumn>
                                        }
                                        <TableRowColumn><ExceptionColumn punch={row.Punch} /></TableRowColumn>
                                        <TableRowColumn>{dateTimeLocal.format("MMM. DD, YYYY")}</TableRowColumn>
                                        <TableRowColumn>{dateTimeLocal.format("h:mm A")}</TableRowColumn>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>

                }
            </Paper>
        )
    }
}